<template>
  <div>
      <courseEvaluateCommon :current="currentCourse"></courseEvaluateCommon>
  </div>
</template>

<script>
import courseEvaluateCommon from '../course-evaluation-A/components/course-evaluate-common.vue'
  export default {
      components:{
          courseEvaluateCommon
      },
      data(){
        return {
          currentCourse:'VIP'
        }
      }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/service/multimedia-vip/index.vue